export default "__VITE_ASSET__12098539__"